import _ from 'lodash';

// eslint-disable-next-line import/prefer-default-export
export const mapElements = elements => {
  const options = [];
  _.each(elements, element => {
    options.push({
      label: element.parent_name ? `${element.parent_name}: ${element.name}` : element.name,
      value: element.id,
    });
  });
  return _.sortBy(options, 'label');
};
